import {
	SET_PRICES_LISTS_APPLY,
	SET_PRICES_LISTS_APPLY_SUCCESS,
	SET_PRICES_LISTS_PAGINATE,
	SET_PRICES_LISTS_PAGINATE_SUCCESS,
	SET_PRICES_LISTS_RECORD,
	SET_PRICES_LISTS_RECORD_SUCCESS
} from 'constants/ActionsTypes'
import {
	IPricesListsUpdateApply,
	IPricesListsUpdateApplyRes,
	IPricesListsUpdatePaginate,
	IPricesListsUpdatePaginateRes,
	IPricesListsUpdateRecord,
	IPricesListsUpdateRecordRes
} from 'models/PricesListsMassiveUpdate'

export const pricesListsUpdateApply = (payload: IPricesListsUpdateApply) => {
	return {
		type: SET_PRICES_LISTS_APPLY,
		payload
	}
}
export const pricesListsUpdateApplySuccess = (
	payload: IPricesListsUpdateApplyRes
) => {
	return {
		type: SET_PRICES_LISTS_APPLY_SUCCESS,
		payload
	}
}
export const pricesListsUpdateRecord = (payload: IPricesListsUpdateRecord) => {
	return {
		type: SET_PRICES_LISTS_RECORD,
		payload
	}
}
export const pricesListsUpdateRecordSuccess = (
	payload: IPricesListsUpdateRecordRes
) => {
	return {
		type: SET_PRICES_LISTS_RECORD_SUCCESS,
		payload
	}
}
export const pricesListsUpdatePaginate = (
	payload: IPricesListsUpdatePaginate
) => {
	return {
		type: SET_PRICES_LISTS_PAGINATE,
		payload
	}
}
export const pricesListsUpdatePaginateSuccess = (
	payload: IPricesListsUpdatePaginateRes
) => {
	return {
		type: SET_PRICES_LISTS_PAGINATE_SUCCESS,
		payload
	}
}
